module.exports = __webpack_public_path__ + "img/smile-svg.6b6241c9.svg";